export default __webpack_public_path__ + "static/media/txt-icon.c8de6b9f.svg";